import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Flame } from "lucide-react";
import { api } from "@/lib/api";

export function RankBadges({ slug }) {
  const [r, setR] = useState(null);
  useEffect(() => { setR(null); api.get(`/home/rank/${slug}`).then((x) => setR(x.data)).catch(() => {}); }, [slug]);
  if (!r) return null;
  const w = r.week?.rank, d = r.day?.rank;
  const items = [];
  if (w && w <= 10) items.push({ k: "week", I: Trophy, t: w === 1 ? "#1 this week" : `Top 10 this week · #${w}`, c: "from-amber-300 to-orange-500 text-black" });
  else if (w && w <= 100) items.push({ k: "week100", I: Trophy, t: `Top 100 this week · #${w}`, c: "from-cyan-400/30 to-fuchsia-500/30 text-white border border-cyan-300/40" });
  if (d && d <= 10 && (!r.day.prev || r.day.prev > d)) items.push({ k: "day", I: Flame, t: `Trending today · #${d}`, c: "from-rose-500 to-fuchsia-500 text-white" });
  if (!items.length) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-3" data-testid="rank-badges">
      {items.map(({ k, I, t, c }) => (
        <Link key={k} to="/#top-apps" className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-black bg-gradient-to-r ${c} shadow-[0_0_18px_-4px_rgba(251,191,36,.7)] hover:scale-105 transition-transform`} data-testid={`rank-badge-${k}`}>
          <I className="w-3.5 h-3.5" />{t}
        </Link>
      ))}
    </div>
  );
}
